import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import PopularComics from './components/PopularComics';
import CTASection from './components/CTASection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const homePageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫免费漫画_在线阅读韩漫大全_好看的韩国漫画下拉式-韩国漫画网',
    description: '在韩国漫画网阅读韩漫免费漫画，在线阅读韩漫大全中的好看韩国漫画，下拉式模式让您的浏览体验更加轻松愉悦。',
    url: 'http://dakunkj.cn/',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩国漫画网',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homePageSchema)}</script>
      <SEOHead />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturesSection />
          <PopularComics />
          <CTASection />
          <TestimonialsSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}